// Extend the Chart to draw a vertical line over data points
const tooltipLinePlugin = {
	afterDatasetsDraw: function (chart) {
		if (chart.tooltip._active && chart.tooltip._active.length) {
			var activePoint = chart.tooltip._active[0],
				ctx = chart.ctx,
				y_axis = chart.scales['y-axis-0'],
				x = activePoint.tooltipPosition().x,
				topY = y_axis.top,
				bottomY = y_axis.bottom;
			// draw line
			ctx.save();
			ctx.beginPath();
			ctx.moveTo(x, topY);
			ctx.lineTo(x, bottomY);
			ctx.lineWidth = 1;
			ctx.strokeStyle = '#e6e6e6';
			ctx.stroke();
			ctx.restore();
		}
	},
};

const highlightPeriodPlugin = {
	afterDatasetsDraw: chart => {
		const pluginOptions = chart.config.options.plugins;
		if (pluginOptions && pluginOptions.highlightPeriod) {
			if (!pluginOptions.highlightPeriod.startDate) {
				return;
			}
			if (!pluginOptions.highlightPeriod.endDate) {
				return;
			}

			const ctx = chart.ctx;
			const y_axis = chart.scales['y-axis-0'];
			const topY = y_axis.top;
			const bottomY = y_axis.bottom;
			const xAxis = chart.scales['x-axis-0'];

			const startDatePosition = xAxis.getPixelForValue(pluginOptions.highlightPeriod.startDate);
			const endDatePosition = xAxis.getPixelForValue(pluginOptions.highlightPeriod.endDate);
			ctx.save();

			ctx.fillStyle = 'rgba(255,255,255,0.5)';
			const startWidth = startDatePosition - xAxis.left;
			const endWidth = xAxis.right - endDatePosition;
			if (startWidth > 0) {
				ctx.fillRect(xAxis.left, topY, startWidth, bottomY - topY);
			}
			if (endWidth > 0) {
				ctx.fillRect(endDatePosition, topY, endWidth, bottomY - topY);
			}

			ctx.beginPath();
			ctx.lineWidth = 1;
			ctx.strokeStyle = '#e6e6e6';
			if (startWidth > 0) {
				ctx.moveTo(startDatePosition, topY);
				ctx.lineTo(startDatePosition, bottomY);
				ctx.stroke();
			}
			if (endWidth > 0) {
				ctx.moveTo(endDatePosition, topY);
				ctx.lineTo(endDatePosition, bottomY);
				ctx.stroke();
			}

			ctx.restore();
		}
	},
};

export const budgetChartPlugins = [tooltipLinePlugin, highlightPeriodPlugin];
